export default function plurialFormatter(count, singular, plural) {
  return count > 1 ? plural : singular;
}
